import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Shield, Users, Eye, Scale, Lock, Heart } from 'lucide-react';

const principles = [
  {
    icon: Scale,
    title: "Fairness & Non-Discrimination",
    description: "Duty AI uses standardized questions and objective rubrics for every candidate. By removing \"gut feeling\" from the process, Duty AI ensures fair, defensible hiring decisions based on data—not bias."
  },
  {
    icon: Eye,
    title: "Transparency",
    description: "We believe candidates deserve to know how they are being evaluated. Duty AI provides clear communication about the interview process, how responses are assessed, and what happens with their data."
  },
  {
    icon: Shield,
    title: "Third-Party Audited",
    description: "Duty AI has passed independent third-party bias audits to ensure our AI systems meet the highest standards of fairness and compliance, including NYC Local Law 144 requirements."
  },
  {
    icon: Users,
    title: "Inclusive by Design",
    description: "With support for 26+ languages and diverse accent recognition, Duty AI ensures every candidate can interview comfortably—regardless of their background, location, or native language."
  },
  {
    icon: Lock,
    title: "Data Privacy & Security",
    description: "Candidate data is handled with the highest security standards. We comply with GDPR, CCPA, and other regional privacy regulations. Your data is never sold to third parties."
  },
  {
    icon: Heart,
    title: "Human-Centered AI",
    description: "Duty AI augments human recruiters, it doesn't replace them. Our AI handles the busywork so recruiters can focus on what matters most—building genuine human connections with candidates."
  }
];

const EthicalAIPage = () => {
  return (
    <>
      <Navbar />
      <main className="bg-[#F9FBF5] min-h-screen">
        <section className="pt-20 lg:pt-32 pb-16">
          <div className="max-w-[1121px] mx-auto px-6 lg:px-10">
            <h1 className="text-[#082900] text-[36px] lg:text-[64px] font-light leading-[1.05] tracking-[-0.011em] mb-4">
              Ethical AI
            </h1>
            <p className="text-[#082900]/60 text-[16px] lg:text-[18px] font-normal max-w-2xl mb-8">
              Our commitment to building AI that is fair, transparent, and human-centered.
            </p>
            <p className="text-[#082900]/80 text-[14px] lg:text-[16px] font-normal max-w-3xl leading-relaxed mb-20">
              At Duty AI, we believe that AI in hiring carries a profound responsibility. Every interaction our AI has with a candidate can shape their career trajectory. That's why we've built ethical principles into the foundation of everything we do—not as an afterthought, but as a core part of our product and culture.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10 mb-20">
              {principles.map((p, i) => (
                <div key={i} className="bg-white rounded-2xl p-8 border border-[#082900]/5">
                  <p.icon className="w-8 h-8 text-[#082900] mb-5" strokeWidth={1.5} />
                  <h3 className="text-[#082900] text-[18px] lg:text-[20px] font-normal mb-3">{p.title}</h3>
                  <p className="text-[#082900]/60 text-[14px] lg:text-[15px] font-normal leading-relaxed">{p.description}</p>
                </div>
              ))}
            </div>

            <div className="bg-[#082900] rounded-2xl p-10 lg:p-16">
              <h2 className="text-[#EEF2E1] text-[24px] lg:text-[36px] font-light leading-[1.1] mb-4">
                96% of candidates rate Duty AI 5 stars
              </h2>
              <p className="text-[#EEF2E1]/60 text-[14px] lg:text-[16px] font-normal max-w-2xl leading-relaxed mb-8">
                Our ethical approach isn't just the right thing to do—it creates better outcomes for everyone. Candidates feel respected, companies get better hires, and the entire hiring process becomes more equitable.
              </p>
              <a href="/demo" className="inline-block px-8 py-3.5 border border-[#EEF2E1]/30 text-[#EEF2E1] text-[14px] font-normal rounded-full hover:bg-[#EEF2E1]/10 transition-colors duration-300">
                Request a demo
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default EthicalAIPage;
